import axios from 'axios';
import { req , reqGet } from './axiosFun';

// 获取用户菜单
export const menu = () => { return req("get","/api/sys/Menu/User") };

// 退出接口
export const loginout = () => { return axios.delete("/api/login?&token=" + localStorage.getItem('logintoken')).then(res => res.data) };

//系统用户列表
export const c2cUsers = (params) => { return req("post", "/api/C2CManager/C2CUsers", params) };
// 添加
export const c2cAddC2CUser = (params) => { return req("post", "/api/C2CManager/AddC2CUser", params) };
// id禁用，启用
export const c2cDisableSwitch = (params) => { return req("post", "/api/C2CManager/DisableSwitch", params) };
// 订单列表
export const c2cOrders = (params) => { return req("post", "/api/C2CManager/Orders", params) };
// 交易记录
export const c2cBills = (params) => { return req("post", "/api/C2CManager/Bills", params) };
export const c2cBurnList = (params) => { return req("post", "/api/C2CManager/BurnList", params) };


// 矿机中心
// 数据中心-矿机订单
export const ordersList = (params) => { return req("post", "/api/m/Miner/Orders", params) };
export const ordersIdList = () => { return req("post", "/api/m/Miner/SysMiners") };
export const userSumsList = (params) => { return req("post", "/api/m/Miner/UserSums", params) };
export const sumsList = () => { return req("post", "/api/m/Miner/Sums") };
export const updateOffset = (params) => { return req("post", "/api/m/Miner/UpdateOffset", params) };
export const updateStatus = (params) => { return req("post", "/api/m/Miner/UpdateStatus", params) };
// 转移
export const MoveMiner = (params) => { return req("post", "/api/m/Miner/MoveMiner", params) };


// 视频资讯
// 分类列表
export const Categorys = (params) => { return req("post", "/api/m/Message/Categorys", params) };
// 添加分类
export const AddCategory = (params) => { return req("post", "/api/m/Message/AddCategory", params) };
// 修改分类
export const UpdateCategory = (params) => { return req("post", "/api/m/Message/UpdateCategory", params) };
// 列表
export const mNews = (params) => { return req("post", "/api/m/Message/News", params) };
export const AddNews = (params) => { return req("post", "/api/m/Message/AddNews", params) };
export const UpdateNews = (params) => { return req("post", "/api/m/Message/UpdateNews", params) };

/**
 * Lucky配置
 **/
 
 export const LWithdrawConfigs = (params) => { return req("post", "/api/SysConfig/LWithdrawConfigs", params) };
 export const SetLWithdrawConfigs = (params) => { return req("post", "/api/SysConfig/SetLWithdrawConfigs", params) };
 export const LWithdrawWhiteList = (params) => { return req("post", "/api/SysConfig/LWithdrawWhiteList", params) };
 export const AddLWithdrawWhiteList = (params) => { return req("post", "/api/SysConfig/AddLWithdrawWhiteList", params) };
 export const DelLWithdrawWhiteList = (params) => { return req("post", "/api/SysConfig/DelLWithdrawWhiteList", params) };

/**
 * 钱包管理
 **/
// 钱包管理-转入列表
export const depositList = (params) => { return req("post", "/api/m/Wallet/DepositList", params) };
// 钱包管理-转出列表
export const withdrawList = (params) => { return req("post", "/api/m/Wallet/WithdrawList", params) };
// 钱包管理-转出审核
export const withdrawCheck = (params) => { return req("post", "/api/m/Wallet/WithdrawCheck", params) };
// 钱包管理-转出退回
// export const withdrawBack = (params) => { return req("post", "/api/m/Wallet/WithdrawBack", params) };
// 钱包管理-转出重试
// export const withdrawRetry = (params) => { return req("post", "/api/m/Wallet/WithdrawRetry", params) };
export const withdrawBackRetry = (params,url) => { return req("post", "/api/m/Wallet/"+url, params) };
// 当前转出用户信息
export const activeWithdrawUser = () => { return req("post", "/api/m/Wallet/ActiveWithdrawUser") };
export const withdrawUsers = () => { return req("post", "/api/m/Wallet/WithdrawUsers") };
export const setWithdrawUserActive = (params) => { return req("post", "/api/m/Wallet/SetWithdrawUserActive", params) };
export const addWithdrawUser = (params) => { return req("post", "/api/m/Wallet/AddWithdrawUser", params) };
export const blockBalance = (params) => { return req("post", "/api/m/Wallet/BlockBalance", params) };
export const WithdrawUserInfo = (params) => { return req("post", "/api/m/Wallet/WithdrawUserInfo", params) };
// 定存复投
export const StakeList = (params) => { return req("post", "/api/m/Wallet/StakeList", params) };
// 兑换列表
export const ExchangeList = (params) => { return req("post", "/api/m/Wallet/ExchangeList", params) };
//转入统计
export const DepositSum = (params) => { return req("post", "/api/m/Wallet/DepositSum", params) };
// 转出统计
export const WithdrawSum = (params) => { return req("post", "/api/m/Wallet/WithdrawSum", params) };
// 复投统计
export const StakeSum = (params) => { return req("post", "/api/m/Wallet/StakeSum", params) };
// 兑换统计
export const ExchangeSum = (params) => { return req("post", "/api/m/Wallet/ExchangeSum", params) };




// 钱包管理-转移列表
export const MoveListList = (params) => { return req("post", "/api/m/Wallet/MoveList", params) };
export const MoveCheck = (params) => { return req("post", "/api/m/Wallet/MoveCheck", params) };
export const MoveUser = () => { return req("post", "/api/m/Wallet/MoveUser") };

export const TransferInList = (params) => { return req("post", "/api/m/Wallet/TransferInList", params) };
export const XySum = (params) => { return req("post", "/api/m/Wallet/XySum", params) };
export const XyList = (params) => { return req("post", "/api/m/Wallet/XyList", params) };
export const ProxyList = (params) => { return req("post", "/api/m/Wallet/ProxyList", params) };
export const RoomList = (params) => { return req("post", "/api/m/Wallet/RoomList", params) };
export const RoomPlaysList = (params) => { return req("post", "/api/m/Wallet/RoomPlaysList", params) };
export const DxOrders = (params) => { return req("post", "/api/m/Wallet/DxOrders", params) };
export const SwitchWhite = (params) => { return req("post", "/api/m/Wallet/SwitchWhite", params) };



// 数据中心-历史数据
export const historyList = (params) => { return req("post", "/api/m/Sum/History", params) };
// 数据中心-今日数据
export const todayList = () => { return req("post", "/api/m/Sum/Today") };
// 数据中心-游戏流水
export const GameBills = (params) => { return req("post", "/api/m/Sum/GameBills", params) };
export const DownLoadGameBills = (params) => { return reqGet("post","/api/m/Sum/DownLoadGameBills",params) };

/**
 * 用户管理 
 **/
// 用户管理-获取用户列表
export const userList = (params) => { return req("post", "/api/m/User/List", params) };
// 用户管理-获取用户列表
export const userList2 = (params) => { return req("post", "/api/m/User/List2", params) };
// 用户管理-获取用户交易密码
export const userClearPwd = (params) => { return req("post", "/api/m/User/ClearUserPwd", params) };
// 用户管理-获取用户邀请列表
export const userInvitList = (params) => { return req("post", "/api/m/User/Downs", params) };
export const UserData = (params) => { return req("post", "/api/Data/UserData", params) };


export const SysData = () => { return req("post", "/api/Data/SysData") };
export const XyTop = (params) => { return req("post", "/api/Data/XyTop", params) };
export const DxTop = (params) => { return req("post", "/api/Data/DxTop", params) };

export const disableWithdraw = (params) => { return req("post", "/api/m/User/DisableWithdraw", params) };
export const enableWithdraw = (params) => { return req("post", "/api/m/User/EnableWithdraw", params) };
export const upper = (params) => { return req("post", "/api/m/User/Upper", params) };
export const upper2 = (params) => { return req("post", "/api/m/User/Upper2", params) };
export const balances = (params) => { return req("post", "/api/m/User/Balances", params) };
export const AddLocker = (params) => { return req("post", "/api/m/User/AddLocker", params) };

// 用户管理-获取用户邀请列表
export const LockList = (params) => { return req("post", "/api/m/User/LockList", params) };LockList

// 用户角色
export const UserRoles = (params) => { return req("post", "/api/m/User/UserRoles", params) };
export const AddUserRole = (params) => { return req("post", "/api/m/User/AddUserRole", params) };
//删除
export const DelUserRole = (params) => { return req("post", "/api/m/User/DelUserRole", params) };
// 参数配置
export const UserConfigs = (params) => { return req("post", "/api/m/User/UserConfigs", params) };
export const AddUserConfig = (params) => { return req("post", "/api/m/User/AddUserConfig", params) };
//删除
export const DelUserConfig = (params) => { return req("post", "/api/m/User/DelUserConfig", params) };




/**
 * 菜单管理
 **/
// 菜单管理-获取菜单Module/list
export const ModuleList = () => { return req("get", "/api/sys/Menu") };
// 菜单管理-根据菜单获取数据
// export const ModuleGet = (params) => { return axios.get("/api/Module/get/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 菜单管理-获取父级菜单Module/nodes
// export const ModuleNodes = (params) => { return req("post", "/api/Module/nodes", params) };
// 菜单管理-修改菜单
export const ModuleSave = (params) => { return req("post", "/api/sys/Menu/Edit", params) };
// 菜单管理-添加菜单
export const ModuleAdd = (params) => { return req("post", "/api/sys/Menu/Create", params) };
// 菜单管理-删除菜单
export const ModuleDelete = (params) => { return req("delete","/api/sys/Menu/" + params) };
// 菜单管理-菜单权限（获取）
export const ModuleTree = () => { return req("get","/api/sys/Permission") };

/**
 * 角色管理 
 **/
// 角色管理-获取角色列表
export const roleList = () => { return req("get", "/api/sys/Role") };
// 角色管理-保存（添加编辑）
export const roleSave = (params) => { return req("post", "/api/sys/Role/Create", params) };
// 角色管理-删除角色
export const roleDelete = (params) => { return req("DELETE","/api/sys/Role/" + params) };
// 角色管理-菜单权限（获取）
export const RoleRightTree = (params) => { return req("get","/api/sys/Role/Permissions?id="+ params) };
// 角色管理-菜单权限（保存）
export const RoleRightSave = (params) => { return req("post", "/api/sys/Role/EditPermissions", params) };

/**
 * 公司管理  组织列表
 **/
// 公司管理-获取组织列表
export const orgList = () => { return req("get", "/api/sys/Org") };
// 公司管理-组织创建
export const orgSave = (params) => { return req("post", "/api/sys/Org/Create", params) };
// 公司管理-删除组织
export const orgDelete = (params) => { return req("DELETE","/api/sys/Org/" + params) };

// 公司管理-获取部门列表
export const deptList = (params) => { return req("get", "/api/sys/Department/"+ params) };
// 公司管理-部门创建
export const deptSave = (params) => { return req("post", "/api/sys/Department/Create", params) };
// 公司管理-删除部门
export const deptDelete = (params) => { return req("DELETE","/api/sys/Department/" + params) };

// 公司管理-获取部门角色列表
export const deptRoleList = (params) => { return req("get", "/api/sys/Department/Roles?id="+ params) };
// 公司管理-保存部门角色
export const deptRoleSave = (params) => { return req("post", "/api/sys/Department/RoleCreate", params) };
// 公司管理-删除角色
export const deptRoleDelete = (params) => { return req("DELETE","/api/sys/Department/Role",params) };

// 公司管理-获取部门用户列表
export const deptUserList = (params) => { return req("get", "/api/sys/Department/Users?id="+ params) };
// 公司管理-添加部门用户
export const deptUserCreate = (params) => { return req("post", "/api/sys/Department/UserCreate", params) };
// 公司管理-删除用户
export const deptUserDelete = (params) => { return req("DELETE","/api/sys/Department/User",params) };

/**
 * 系统环境变量 
 **/
// 系统环境变量-获取系统环境变量列表
export const variableList = (params) => { return req("post", "/api/Variable/list", params) };
// 系统环境变量-保存（添加编辑）
export const variableSave = (params) => { return req("post", "/api/Variable/save", params) };
// 系统环境变量-删除系统环境变量
export const variableDelete = (params) => { return axios.delete("/api/Variable/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };

/**
 * 权限管理 
 **/
// 权限管理-获取权限列表
export const permissionList = (params) => { return req("post", "/api/Permission/list", params) };
// 权限管理-保存权限
export const ermissionSave = (params) => { return req("post", "/api/Permission/save", params) };
// 权限管理-删除权限
export const ermissionDelete = (params) => { return axios.delete("/api/Permission/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 权限管理-获取权限
export const roleDropDown = () => { return axios.get("/api/Role/dropDown/all?&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 权限管理-配置权限
export const RolePermission = (params) => { return req("post", "/api/RolePermission/save", params) };


// WEBPACK FOOTER //
// ./src/api/userMG.js